"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Filter_exports = {};
__export(Filter_exports, {
  default: () => Filter_default
});
module.exports = __toCommonJS(Filter_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.5 6.3999H10.94C10.662 5.03061 9.45134 4 8 4C6.54866 4 5.33803 5.03061 5.06003 6.3999H3.49999C3.16862 6.3999 2.89999 6.66853 2.89999 6.9999C2.89999 7.33127 3.16862 7.5999 3.49999 7.5999H5.05999C5.33792 8.9693 6.54859 10 8 10C9.45141 10 10.6621 8.9693 10.94 7.5999H20.5C20.8314 7.5999 21.1 7.33127 21.1 6.9999C21.1 6.66853 20.8314 6.3999 20.5 6.3999ZM3.49999 16.3999C3.16862 16.3999 2.89999 16.6685 2.89999 16.9999C2.89999 17.3313 3.16862 17.5999 3.49999 17.5999H13.06C13.3379 18.9693 14.5486 20 16 20C17.4514 20 18.6621 18.9693 18.94 17.5999H20.5C20.8314 17.5999 21.1 17.3313 21.1 16.9999C21.1 16.6685 20.8314 16.3999 20.5 16.3999H18.94C18.662 15.0306 17.4513 14 16 14C14.5487 14 13.338 15.0306 13.06 16.3999H3.49999Z",
      fill: "currentColor"
    }
  )
);
const SvgFilter = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Filter_default = SvgFilter;
